import React, { useState } from 'react';
import { trackWindowScroll } from 'react-lazy-load-image-component';

const LazyImageContext = React.createContext({});

const BaseLazyImageProvider = ({ children, scrollPosition }) => {
  const [loadedImages, setLoadedImages] = useState(new Map());

  const afterLoad = (src) => {
    if (loadedImages && !loadedImages.get(src)) {
      setLoadedImages(loadedImages.set(src, 'loaded'));
    }
  };

  const lazyImageData = { afterLoad, loadedImages, scrollPosition };

  return (
    <LazyImageContext.Provider value={lazyImageData}>
      {children}
    </LazyImageContext.Provider>
  );
};

const LazyImageProvider = trackWindowScroll(BaseLazyImageProvider);

export { LazyImageProvider };

export default LazyImageContext;
